import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingInventory(props) {
  const oldData = (props.listingData && props.listingData.catalogData) || {};

  const [inventory, setInventory] = useState(
    props.listingData && props.listingData.inventory || {
      fulfillment: props.listingData && props.listingData.formData && props.listingData.formData.fulfillment || "FBM",
      quantity: props.listingData && props.listingData.formData && props.listingData.formData.quantity || "",
      warehouse: props.listingData && props.listingData.formData && props.listingData.formData.warehouse || ""
    }
  );

  useEffect(() => {
    if (props.listingData) {
      setInventory({
        fulfillment: props.listingData && props.listingData.formData && props.listingData.formData.fulfillment || "FBM",
        quantity: props.listingData && props.listingData.formData && props.listingData.formData.quantity || "",
        warehouse: props.listingData && props.listingData.formData && props.listingData.formData.warehouse || ""
      });
    }
  }, [props.listingData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInventory(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNext = () => {
    if (inventory.fulfillment === "FBM") {
      if (!inventory.quantity || !inventory.warehouse) {
        alert("Please fill Quantity and Warehouse for FBM");
        return;
      }
    }

    props.setListingData(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        fulfillment: inventory.fulfillment,
        quantity: inventory.quantity,
        warehouse: inventory.warehouse
      }
    }));
    props.nextStep();
  };

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 8 : Inventory</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">

            {/* Column Headers */}
            <Row className="mb-4 text-center">
              <Col md={2} className="text-left"></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            {/* Fulfillment */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Fulfillment Method :
              </Col>

              <Col md={4}>
                <p className="mb-0">{oldData.fulfillment || "N/A"}</p>
              </Col>

              <Col md={6}>
                <div className="d-flex ml-3">
                  <div className="mr-3">
                    <Input
                      type="radio"
                      name="fulfillment"
                      value="FBM"
                      checked={inventory.fulfillment === "FBM"}
                      onChange={handleChange}
                    />
                    {" "}Merchant Fulfilled (FBM)
                  </div>
                  <div className="ml-3">
                    <Input
                      type="radio"
                      name="fulfillment"
                      value="FBA"
                      checked={inventory.fulfillment === "FBA"}
                      onChange={handleChange}
                    />
                    {" "}Fulfilled by Amazon (FBA)
                  </div>
                </div>
              </Col>
            </Row>

            {/* Quantity */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Quantity :
              </Col>

              <Col md={4}>
                <p className="mb-0">{oldData.quantity || "N/A"}</p>
              </Col>

              <Col md={6}>
                <Input
                  type="number"
                  name="quantity"
                  value={inventory.quantity || ""}
                  onChange={handleChange}
                  placeholder="Enter quantity"
                  disabled={inventory.fulfillment === "FBA"}
                />
              </Col>
            </Row>

            {/* Warehouse */}
            <Row className="mb-3 align-items-center">
              <Col md={2} className="amazon-listing-labels">
                Warehouse :
              </Col>

              <Col md={4}>
                <p className="mb-0">{oldData.warehouse || "N/A"}</p>
              </Col>

              <Col md={6}>
                <Input
                  type="text"
                  name="warehouse"
                  value={inventory.warehouse || ""}
                  onChange={handleChange}
                  placeholder="Enter warehouse name"
                  disabled={inventory.fulfillment === "FBA"}
                />
              </Col>
            </Row>

          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={handleNext}
          >
            Next →
          </button>
        </Col>

      </Row>
    </Container>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(ProductListingInventory);